module.exports = __webpack_public_path__ + "img/help.59515807.png";